module.exports = require("repl");


//////////////////
// WEBPACK FOOTER
// external "repl"
// module id = 76
// module chunks = 0